<template>
  <div class="uk-grid-medium" uk-grid>
    <div class="uk-width-5-5">
      <div class="d-flex">
        <nav id="breadcrumbs" class="mb-3">
          <ul>
            <li>
              <router-link :to="{ name: 'company.dashboard' }">
                <i class="uil-home-alt"></i>
              </router-link>
            </li>
            <li>{{ $t('general.authorization') }}</li>
            <li>{{ this.$route.params.id ? $t('general.update_role') : $t('general.add_new_role') }}</li>
          </ul>
        </nav>
      </div>

      <div class="card authorization-add-edit-roles" style="padding:1.5rem">
        <div class="uk-margin">
          <label class="uk-form-label">{{ $t('general.role_name') }}*</label>
          <input v-model="roleName" class="uk-input" :placeholder="$t('general.role_name')" type="text">
          <!-- <p v-if="errors.roleName" class="error-message">Bu alan zorunludur.</p> -->
        </div>

        <div class="uk-margin">
          <label class="uk-form-label">{{ $t('general.permissions') }}</label>
          <input v-model="search" class="uk-input" :placeholder="$t('general.search')" type="text">
        </div>
        <template>
          <div>
            <!-- Header -->
            <div class="uk-card uk-card-default uk-card-body uk-margin-small">
              <div class="row mb-2 text-center">
                <div class="col-md-3 text-left">
                  <strong>{{ $t('general.group') }}</strong>
                </div>
                <div class="col-md-2">
                  <strong>{{ $t('general.reading') }}</strong>
                </div>
                <div class="col-md-2">
                  <strong>{{ $t('general.viewing') }}</strong>
                </div>
                <div class="col-md-2">
                  <strong>{{ $t('general.creating') }}</strong>
                </div>
                <div class="col-md-2">
                  <strong>{{ $t('general.update_action') }}</strong>
                </div>
                <div class="col-md-1">
                  <strong>{{ $t('general.delete_action') }}</strong>
                </div>
              </div>
            </div>


            <!-- Permission List -->
            <div v-for="(items, group) in filteredPermissions" :key="group"
              class="uk-card uk-card-default uk-card-body uk-margin-small">

              <div v-if="items && items.length" class="row align-items-center text-center">

                <!-- Grup -->
                <div class="col-md-3 text-left font-weight-bold">
                  {{ $t('permission.' + group) }}
                </div>


                <!-- Read -->
                <div class="col-md-2">
                  <label v-if="items.find(p => p.name === 'read_' + group)" class="uk-switch" :uk-tooltip="$t('general.read_authority')">


                    <input type="checkbox" :checked="isSelected(items.find(p => p.name === 'read_' + group))"
                      :disabled="isSystemRole"
                      @change="togglePermission(items.find(p => p.name === 'read_' + group), group)">
                    <div class="uk-switch-slider"></div>
                  </label>
                </div>


                <!-- Show -->
                <div class="col-md-2">
                  <label v-if="items.find(p => p.name === 'show_' + group)" class="uk-switch"
                    :uk-tooltip="$t('general.view_authority')">
                    <input type="checkbox" :checked="isSelected(items.find(p => p.name === 'show_' + group))"
                      :disabled="isSystemRole"
                      @change="togglePermission(items.find(p => p.name === 'show_' + group), group)">
                    <div class="uk-switch-slider"></div>
                  </label>
                </div>


                <!-- Create -->
                <div class="col-md-2">
                  <label v-if="items.find(p => p.name === 'create_' + group)" class="uk-switch"
                    :uk-tooltip="$t('general.create_authority')">
                    <input type="checkbox" :checked="isSelected(items.find(p => p.name === 'create_' + group))"
                      :disabled="isSystemRole"
                      @change="togglePermission(items.find(p => p.name === 'create_' + group), group)">
                    <div class="uk-switch-slider"></div>
                  </label>
                </div>


                <!-- Update -->
                <div class="col-md-2">
                  <label v-if="items.find(p => p.name === 'update_' + group)" class="uk-switch"
                    :uk-tooltip="$t('general.update_authority')">
                    <input type="checkbox" :checked="isSelected(items.find(p => p.name === 'update_' + group))"
                      :disabled="isSystemRole"
                      @change="togglePermission(items.find(p => p.name === 'update_' + group), group)">
                    <div class="uk-switch-slider"></div>
                  </label>
                </div>


                <!-- Delete -->
                <div class="col-md-1">
                  <label v-if="items.find(p => p.name === 'delete_' + group)" class="uk-switch"
                    :uk-tooltip="$t('general.delete_authority')">
                    <input type="checkbox" :checked="isSelected(items.find(p => p.name === 'delete_' + group))"
                      :disabled="isSystemRole"
                      @change="togglePermission(items.find(p => p.name === 'delete_' + group), group)">
                    <div class="uk-switch-slider"></div>
                  </label>
                </div>

              </div>

            </div>
          </div>
        </template>
        <!-- Kaydet Butonu -->
        <div class="uk-margin">
          <button class="uk-button uk-button-primary" @click="saveRole"
            :disabled="roleName === 'company_admin' || roleName === 'super_admin' || roleName === 'user'">{{ $t('general.save') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RolePermissionActions from "@/view/company/Authorization/components/RolePermissionActions.vue";
import axios from "axios";

export default {
  name: "AddRole",
  components: { RolePermissionActions },
  data() {
    return {
      defaultRole: {
        name: "",
        permissions: [],
      },
      deletedPermissions: [],
      id: '',
      page: 'add',
      roleName: '',
      roleType: '',
      search: '',
      errors: {
        roleName: false,
        roleType: false
      },
      permissions: {},
      permissionTypes: ['read', 'show', 'create', 'update', 'delete'],
      role: {
        name: '',
        permissions: []
      },
      selectedPermissions: []
    };
  },
  created() {
    this.defaultRoleBackup = JSON.parse(JSON.stringify(this.defaultRole));
  },
  computed: {
    isSystemRole() {
      return ['company_admin', 'super_admin', 'user'].includes(this.roleName);
    },
    searchLower() {
      return this.search ? this.search.toLowerCase() : '';
    },

    filteredPermissions() {
      if (!this.searchLower) {
        return this.permissions;
      }
      const filtered = {};
      Object.keys(this.permissions).forEach(group => {
        const groupName = this.$t('permission.' + group).toLowerCase();
        if (groupName.includes(this.searchLower)) {
          filtered[group] = this.permissions[group];
        }
      });
      return filtered;
    }
  },
  methods: {
    togglePermission(permission, group) {

      const selected = {
        id: permission.id,
        name: permission.name,
        group_name: group
      };

      const index = this.selectedPermissions.findIndex(
        p => p.id === permission.id
      );

      if (index > -1) {
        this.selectedPermissions.splice(index, 1);
      } else {
        this.selectedPermissions.push(selected);
      }

    },
    isSelected(permission) {
      if (!permission) return false;
      return this.selectedPermissions.some(
        p => p.id === permission.id
      );
    },
    getPermissionLabel(type) {

      const labels = {
        read: this.$t('general.read_authority'),
        show: this.$t('general.view_authority'),
        create: this.$t('general.create_authority'),
        update: this.$t('general.update_authority'),
        delete: this.$t('general.delete_authority')
      };

      return labels[type];

    },
    getPermissions() {
      axios.get('api/permissions', {
        headers: this.apiHeaders
      }).then((result) => {
        this.permissions = result.data;

        // Permissionlar geldikten sonra edit ise role bilgilerini işle
        if (this.page === 'edit') {
          this.getRole();
        }
      });
    },
    getRole() {
      axios.get(`api/roles/${this.id}`, {
        headers: this.apiHeaders
      }).then((result) => {
        this.roleName = result.data.name;
        this.selectedPermissions = [];

        result.data.permissions.forEach(group => {
          group.permissions.forEach(permission => {
            if (permission.assigned) {
              this.selectedPermissions.push({
                id: permission.id,
                name: permission.name,
                group_name: group.group_name
              });
            }
          });
        });
      });
    },
    validateForm() {
      this.errors.roleName = !this.roleName.trim();
      return !this.errors.roleName && !this.errors.roleType;
    },
    saveRole() {
      if (!this.roleName || this.roleName.trim() === '') {
        alert(this.$t('general.please_enter_role_name'));
        return;
      }
      const permissions = {};

      this.selectedPermissions.forEach(permission => {
        if (!permissions[permission.group_name]) {
          permissions[permission.group_name] = [];
        }

        permissions[permission.group_name].push({
          id: permission.id,
          name: permission.name
        });

      });
      const sendData = {
        name: this.roleName.trim(),
        permissions: Object.keys(permissions).map(group => ({
          group_name: group,
          permissions: permissions[group]
        }))
      };
      console.log(sendData);
      debugger

      const request = this.page === 'add'
        ? axios.post(`api/roles`, sendData, { headers: this.apiHeaders })
        : axios.put(`api/roles/${this.id}`, sendData, { headers: this.apiHeaders });

      request
        .then((result) => {
          if (result) {
            const message = this.page === 'add'
              ? this.$t('general.role_saved_successfully')
              : this.$t('general.role_updated_successfully');
            alert(message);
            this.$router.back();
          }
        })
        .catch(error => {
          console.error(error);
          const errorMessage = this.page === 'add'
            ? 'Rol kaydedilirken hata oluştu.'
            : 'Rol güncellenirken hata oluştu.';
          alert(errorMessage);
        });
    },
    updateRole(item) {
      let sendData = {
        roleName: this.roleName,
        roleType: this.roleType,
        permissions: this.permissions
      }
      axios.put(`api/role/` + this.id + '',
        sendData,
        {
          headers: this.apiHeaders
        }).then((result) => {

        })
    }

  },
  mounted() {
    const hash = window.location.hash; // "#/admin/authorization-add-edit-roles/1"
    const parts = hash.split('/');     // ["#", "admin", "authorization-add-edit-roles", "1"]
    this.id = parts[parts.length - 1];

    this.id = this.$route.params.id;
    this.page = this.id ? 'edit' : 'add';
    this.getPermissions();

  }
};
</script>

<style scoped>
.uk-switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 20px;
}

.uk-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.uk-switch-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: .4s;
  border-radius: 34px;
}

.uk-switch-slider:before {
  position: absolute;
  content: "";
  height: 14px;
  width: 14px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: .4s;
  border-radius: 50%;
}

.uk-switch input:checked+.uk-switch-slider {
  background-color: #4caf50;
}

.uk-switch input:checked+.uk-switch-slider:before {
  transform: translateX(20px);
}

.error-message {
  color: red;
  font-size: 12px;
  margin-top: 5px;
}
</style>
